import { postValidateIdentity } from '../api/authApi';
import type { IdentityRequest, IdentityResult, IdentityErrorCode } from '../types/api.types';

export async function verifyIdentity(
  payload: IdentityRequest,
  jwtToken: string,
  formAccessId?: string | null
): Promise<IdentityResult> {
  try {
    const data = await postValidateIdentity(payload, jwtToken, formAccessId);
    return { success: true, sessionToken: data.sessionToken };
  } catch (err: unknown) {
    const e = err as Error & {
      attemptsRemaining?: number;
      captchaId?:         string;
      imageBase64?:       string;
    };
    return {
      success:           false,
      errorCode:         (e.message ?? 'UNKNOWN_ERROR') as IdentityErrorCode,
      attemptsRemaining: e.attemptsRemaining,
      newCaptchaId:      e.captchaId,
      newImageBase64:    e.imageBase64,
    };
  }
}
